Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsBottomSheet = require('../../bottom-sheet');
var mobile = require('../../button/mobile');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"target":"tooltip__target_1ynpi","overlap":"tooltip__overlap_1ynpi","inline":"tooltip__inline_1ynpi"};
require('./mobile.css');

var TooltipMobile = function (_a) {
    var _b;
    var onClose = _a.onClose, _c = _a.actionButtonTitle, actionButtonTitle = _c === void 0 ? 'Понятно' : _c, content = _a.content, targetRef = _a.targetRef, onOpen = _a.onOpen, targetClassName = _a.targetClassName, children = _a.children, getPortalContainer = _a.getPortalContainer, _d = _a.targetTag, TargetTag = _d === void 0 ? 'div' : _d, openProp = _a.open, restProps = tslib.__rest(_a, ["onClose", "actionButtonTitle", "content", "targetRef", "onOpen", "targetClassName", "children", "getPortalContainer", "targetTag", "open"]);
    var _e = React.useState(!!openProp), visible = _e[0], setVisible = _e[1];
    var show = openProp === undefined ? visible : openProp;
    var handleOpen = function () {
        if (!show) {
            if (openProp === undefined)
                setVisible(true);
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    };
    var handleClose = function () {
        if (show) {
            if (openProp === undefined)
                setVisible(false);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    return (React__default.default.createElement(React.Fragment, null,
        React__default.default.createElement(coreComponentsBottomSheet.BottomSheet, tslib.__assign({ open: show, actionButton: React__default.default.createElement(mobile.ButtonMobile, { view: 'secondary', block: true, size: 's', onClick: handleClose }, actionButtonTitle) }, restProps, { container: getPortalContainer, onClose: handleClose }), content),
        React__default.default.createElement(TargetTag, { ref: targetRef, onClick: handleOpen, className: cn__default.default(styles.target, targetClassName, (_b = {},
                _b[styles.inline] = TargetTag === 'span',
                _b)) },
            (children === null || children === void 0 ? void 0 : children.props.disabled) && React__default.default.createElement("div", { className: styles.overlap }),
            children)));
};

exports.TooltipMobile = TooltipMobile;
